import { useSiteContent } from "../contexts/SiteContent";

const DEFAULT_COLS = [
  {
    titleKey: "footer.col_1_title", titleFallback: "Models", linksKey: "footer.col_1_links",
    linksFallback: [{ label: "Gemini", href: "#" }, { label: "Veo", href: "#" }, { label: "Imagen", href: "#" },
                    { label: "AlphaFold", href: "#" }, { label: "AlphaProteo", href: "#" }, { label: "Gemma", href: "#" }],
  },
  {
    titleKey: "footer.col_2_title", titleFallback: "Products", linksKey: "footer.col_2_links",
    linksFallback: [{ label: "Gemini app", href: "#" }, { label: "Gemini Code", href: "#" },
                    { label: "NotebookLM", href: "#" }, { label: "Pixel Studio", href: "#" },
                    { label: "AI Studio", href: "#" }],
  },
  {
    titleKey: "footer.col_3_title", titleFallback: "Research", linksKey: "footer.col_3_links",
    linksFallback: [{ label: "Publications", href: "#" }, { label: "Research areas", href: "#" },
                    { label: "Open source", href: "#" }, { label: "Datasets", href: "#" },
                    { label: "Visiting program", href: "#" }],
  },
  {
    titleKey: "footer.col_4_title", titleFallback: "Science", linksKey: "footer.col_4_links",
    linksFallback: [{ label: "Domains", href: "#domains" }, { label: "Breakthroughs", href: "#breakthroughs" },
                    { label: "Impact", href: "#impact" }, { label: "Resources", href: "#resources" },
                    { label: "Partner with us", href: "#" }],
  },
  {
    titleKey: "footer.col_5_title", titleFallback: "Learn more", linksKey: "footer.col_5_links",
    linksFallback: [{ label: "Responsibility & Safety", href: "#" }, { label: "Education", href: "#" },
                    { label: "Newsroom", href: "#" }, { label: "Brand resources", href: "#" },
                    { label: "Help & support", href: "#" }],
  },
];

const DEFAULT_LEGAL = [
  { label: "About", href: "#" }, { label: "Products", href: "#" },
  { label: "Privacy", href: "#" }, { label: "Terms", href: "#" },
];

export default function Footer({ onOpenContact }) {
  const { t } = useSiteContent();
  return (
    <footer data-testid="footer" className="bg-white border-t border-neutral-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 pt-16 md:pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <h2 className="text-[32px] md:text-[44px] font-semibold tracking-[-0.02em] leading-[1.05] text-neutral-900 max-w-[480px]">
              {t("footer.headline", "Build AI responsibly to benefit humanity")}
            </h2>

            <div className="mt-8">
              <button
                type="button"
                onClick={onOpenContact}
                data-testid="open-contact-modal"
                className="inline-flex items-center gap-2 rounded-full bg-neutral-900 h-11 px-6 text-[14px] font-medium text-white hover:bg-neutral-800"
              >
                {t("footer.contact_label", "Contact us")}
              </button>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-5 gap-8">
            {DEFAULT_COLS.map((col) => {
              const title = t(col.titleKey, col.titleFallback);
              const links = t(col.linksKey, col.linksFallback);
              const safeLinks = Array.isArray(links) ? links : col.linksFallback;
              return (
                <div key={col.titleKey}>
                  <p className="text-[12px] uppercase tracking-[0.18em] font-medium text-neutral-500">
                    {title}
                  </p>
                  <ul className="mt-4 space-y-2.5">
                    {safeLinks.map((l, i) => (
                      <li key={i}>
                        <a
                          href={l.href || "#"}
                          className="text-[13px] text-neutral-700 hover:text-neutral-900"
                        >
                          {l.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-neutral-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-[13px] text-neutral-500 font-medium">
            {t("footer.legal_brand", "Google")}
          </p>
          <ul className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {(Array.isArray(t("footer.legal_links", DEFAULT_LEGAL))
              ? t("footer.legal_links", DEFAULT_LEGAL)
              : DEFAULT_LEGAL
            ).map((l, i) => (
              <li key={i}>
                <a href={l.href || "#"} className="text-[12px] text-neutral-500 hover:text-neutral-900">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
